export default function ReportesIcon({ size, color }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 14" fill="none">
      <path
        d="M15 7.05627H12.2L10.1 13.0563L5.9 1.05627L3.8 7.05627H1"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
